// extracted by mini-css-extract-plugin
export default {"select":"selectComponent_select__0+Viz"};